import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

const identifierRegex = /^([a-zA-Z0-9]|_|-|\.)+$/;

export const isIdentifier = (id: any): id is string =>
  isString(id) && id.length >= 3 && id.length < 100 && identifierRegex.test(id);

export const IsNumericId = (id: any): id is number => isNumber(id) && id >= 0;
